const END_POINT = '/countries'

import BasicCrudAPI from './basicCrud.api.js'

const CountryAPI = new BasicCrudAPI(END_POINT)

export default CountryAPI
